import { z } from 'zod';
import { PopulatedEntitySuggestionSchema } from '../../entities/entity-suggestion';
export const GetEntitySuggestionResponseSchema = z.object({
    data: PopulatedEntitySuggestionSchema
});

//# sourceMappingURL=get-entity-suggestion.contract.js.map